import GA4 from 'react-ga4';
import {
  GOOGLE_MEASUREMENT_ID,
  GOOGLE_ADS_ID,
  GOOGLE_ADS_REVIEW_ID,
  GOOGLE_ADS_SGTM_ID,
  GOOGLE_ADS_LTV_ID_1,
  GOOGLE_ADS_LTV_ID_2,
  GOOGLE_ADS_LTV_ID_3,
  GOOGLE_ADS_LTV_ID_4,
  GOOGLE_ADS_LTV_ID_5,
  GOOGLE_ADS_LTV_ID_6,
  GOOGLE_ADS_LTV_ID_7,
} from '../core/constants';

type GoogleTagEvent = [eventName: string, params: Record<string, unknown>];

const googleTagConfigs = [
  ...new Set(
    [
      GOOGLE_MEASUREMENT_ID,
      GOOGLE_ADS_ID,
      GOOGLE_ADS_REVIEW_ID,
      GOOGLE_ADS_SGTM_ID,
      GOOGLE_ADS_LTV_ID_1,
      GOOGLE_ADS_LTV_ID_2,
      GOOGLE_ADS_LTV_ID_3,
      GOOGLE_ADS_LTV_ID_4,
      GOOGLE_ADS_LTV_ID_5,
      GOOGLE_ADS_LTV_ID_6,
      GOOGLE_ADS_LTV_ID_7,
    ].filter(Boolean),
  ),
].map((trackingId) => ({ trackingId: String(trackingId) }));

const isGoogleTagConfigured = googleTagConfigs.length > 0;

const eventsAwaitingConfig: GoogleTagEvent[] = [];

export const initGoogleTag = () => {
  if (!isGoogleTagConfigured) return;
  GA4.initialize(googleTagConfigs);
  eventsAwaitingConfig.splice(0).forEach(([eventName, params]) => GA4.event(eventName, params));
};

// An event pushed before `config` is still sent, but config-less: Google flags the tag with
// "Missing gtag config command". GA4 waits for GTM, so early events wait for initGoogleTag.
// If GTM never loads, GA4 never starts and the waiting events are dropped with it.
export const sendGoogleTagEvent = (eventName: string, params: Record<string, unknown>) => {
  if (!isGoogleTagConfigured) return;
  if (!GA4.isInitialized) {
    eventsAwaitingConfig.push([eventName, params]);
    return;
  }
  GA4.event(eventName, params);
};
